// extracted by mini-css-extract-plugin
export var arrows = "_2s-5";
export var decrementer = "_2s-9";
export var disabled = "_2s-3";
export var error = "_2s-1";
export var hiddenText = "_2s-a";
export var incrementer = "_2s-8";
export var input = "_2s-7";
export var inputWrapper = "_2s-0";
export var leadingIcon = "_2s-b";
export var readonly = "_2s-2";
export var regular = "_2s-6";
export var small = "_2s-4";